<template>
  <div>
    <nuxt-link :to="link" target="_blank" class="booking-similar-tour-link">
      <div class="booking-similar-tour-card">
        <div class="booking-similar-tour-card-content">
          <div class="booking-similar-tour-card-img-wrapper">
            <img
              class="booking-similar-tour-card-img lazyload"
              :data-src="imgUrl"
              format="webp"
              loading="lazy"
              width="120"
              height="120"
              :alt="tour.listingImageTitle"
            >
          </div>

          <span class="booking-similar-tour-card-title">
            {{ tour.shortTitle }}
          </span>
        </div>

        <div
          v-if="review.stars !== 0 || price"
          class="booking-similar-tour-card-footer"
        >
          <ReviewLine
            v-if="review.stars !== 0"
            class="booking-similar-tour-card-review-line"
            :icon-size="iconSize"
            :show-hours="false"
            :show-capacity="false"
            :review="review"
          />

          <div v-if="review.stars == 0" />

          <div v-if="price" class="booking-similar-tour-card-price">
            <span class="booking-similar-tour-card-price-text">From</span>
            <span class="booking-similar-tour-card-price-value" :class="{ 'discounted': discountedPrice }">{{ priceUnit }}{{ price }}</span>
            <span v-if="discountedPrice" class="booking-similar-tour-card-price-discounted">{{ priceUnit }}{{ discountedPrice }}</span>
          </div>
        </div>
      </div>
    </nuxt-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReviewLine from '@/components/utils/ReviewLine'
import { getTourPriceNum, getDetailedPrefixSymbol, getDiscountedTourPriceNum } from '@/helpers/price'

export default {
  name: 'BookingSimilarTour',
  components: {
    ReviewLine
  },
  props: {
    tour: {
      type: Object,
      require: true
    },
    detailMode: {
      type: Number,
      require: false,
      default: () => 1
    },
    iconSize: {
      type: String,
      require: false,
      default: () => '16px'
    }
  },
  computed: {
    ...mapGetters([
      'currency',
    ]),
    priceUnit () {
      const curCurrency = this.currency
      return getDetailedPrefixSymbol(curCurrency)
    },
    price () {
      const curCurrency = this.currency
      if (!this.tour.priceMap) {
        return 0
      }

      const price = getTourPriceNum(this.tour.priceMap, curCurrency, false)
      return price || 0
    },
    discountedPrice () {
      const curCurrency = this.currency
      if (!this.tour.priceMap) {
        return 0
      }

      const price = getDiscountedTourPriceNum(this.tour.priceMap, curCurrency, false)
      return price || 0
    },
    link () {
      return `/${this.tour.citySlug}/${this.tour.tourPageUrl}/`
    },
    review () {
      return {
        stars: this.tour.reviewStatus?.feedbackAverage || 0,
        reviewNumber: this.tour.reviewStatus?.feedbackCount || 0,
        thirdPartyTotalReview: this.tour.reviewStatus?.thirdPartyTotalReview || 0
      }
    },
    imgUrl () {
      return this.tour.listingImage
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-similar-tour-card {
  padding: 8px;
  border-radius: 8px;

  width: 100%;
  max-width: 100%;
  border: 1px solid #fff;

  .booking-similar-tour-card-content {
    gap: 8px;
    display: flex;
    align-items: flex-start;
  }

  .booking-similar-tour-card-footer {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  .booking-similar-tour-card-img-wrapper {
    width: 117px;
    height: 72px;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: 4px;
    background-color: #68626c;
  }

  .booking-similar-tour-card-title {
    @include font__paragraph-1--medium();
    color: $brand-primary-color;
  }

  .booking-similar-tour-card-img {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 4px;
  }

  .booking-similar-tour-card-review-line {
    color: #889BAA;
  }

  .booking-similar-tour-card-price {
    @include font__description-2--bold();
    text-align: right;
    color: $blackberry;
  }

  .booking-similar-tour-card-price-value.discounted {
    text-decoration: line-through;
  }

  .booking-similar-tour-card-price-discounted {
    color: $woi-gold-main;
  }
}
</style>

<style lang="scss">
.booking-similar-tour-card {
  .booking-similar-tour-card-footer {
    .booking-similar-tour-card-review-line {
      .subtitle {
        position: relative;
        top: 2px;
        @include font__description-1--regular();
        font-size: 14px !important;
        line-height: 16px !important;
      }
    }
  }
}
</style>
